var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00018 1.38978C1.00339 1.48626 1.04648 1.57782 1.12035 1.64499L6.71623 6.89145C6.79046 6.96091 6.8911 7 6.99603 7C7.10095 7 7.20159 6.96091 7.27582 6.89145L12.8717 1.64499C12.9513 1.57651 12.9976 1.48052 12.9999 1.37936C13.0022 1.27812 12.9604 1.18032 12.884 1.10872C12.8076 1.03712 12.7033 0.997873 12.5954 1.00009C12.4874 1.00231 12.3851 1.04566 12.3121 1.1203L6.99603 6.10442L1.67994 1.1203C1.60536 1.04837 1.50293 1.00789 1.39595 1.00789C1.28896 1.00789 1.18655 1.04854 1.11195 1.12046C1.03745 1.19239 0.997126 1.28953 1.00016 1.38978L1.00018 1.38978Z",
    fill: "#8F9EA9",
    stroke: "#8F9EA9",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGrey);
export default __webpack_public_path__ + "static/media/arrowDownGrey.3ccd655998a926ebe669a456bc513cee.svg";
export { ForwardRef as ReactComponent };